import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { extractError } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const OfferReport = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/admin/offer-report").then((r) => setRows(r.data.rows || [])).catch((err) => toast.error(extractError(err))).finally(() => setLoading(false));
  }, []);

  const sum = (k) => rows.reduce((a, r) => a + r[k], 0);
  const totals = [["Used code", "redeemed"], ["In free period", "in_free_period"], ["Paid after trial", "converted"], ["Dropped", "dropped"]];

  return (
    <div data-testid="offer-report">
      <h2 className="font-display text-2xl font-bold">Offer report</h2>
      <p className="text-sm text-muted-foreground mt-1 mb-4">Free-trial codes per tool. "Paid after trial" means the first auto-debit after the free period went through. "Dropped" means they cancelled or the payment failed.</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {totals.map(([label, k]) => (
          <div key={k} className="border border-border rounded-sm bg-card p-4">
            <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{label}</div>
            <div className="font-display font-black text-3xl mt-1" data-testid={`offer-total-${k}`}>{sum(k)}</div>
          </div>
        ))}
      </div>
      {loading ? <div className="text-sm text-muted-foreground font-mono">Loading...</div> : (
        <div className="border border-border rounded-sm overflow-x-auto">
          <Table>
            <TableHeader><TableRow>
              <TableHead>Code</TableHead><TableHead>Tool</TableHead>
              <TableHead className="text-right">Used code</TableHead><TableHead className="text-right">In free period</TableHead>
              <TableHead className="text-right">Paid after trial</TableHead><TableHead className="text-right">Dropped</TableHead><TableHead className="text-right">Stayed %</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={`${r.coupon_code}-${r.tool_id}`} data-testid={`offer-row-${r.coupon_code}-${r.tool_id}`}>
                  <TableCell className="font-mono text-xs text-primary">{r.coupon_code}</TableCell>
                  <TableCell className="text-sm">{r.tool_name}</TableCell>
                  <TableCell className="text-right font-mono">{r.redeemed}</TableCell>
                  <TableCell className="text-right font-mono">{r.in_free_period}</TableCell>
                  <TableCell className="text-right font-mono text-primary">{r.converted}</TableCell>
                  <TableCell className="text-right font-mono text-destructive">{r.dropped}</TableCell>
                  <TableCell className="text-right font-mono">{r.conversion_pct === null ? "—" : `${r.conversion_pct}%`}</TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-sm text-muted-foreground py-8">No one has used a free-trial code yet.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
